import vue from "vue";
import { initialState } from "./initialState";
import localForage from "localforage";
export default {
    SET_CATEGORIES: (state, categories) => {
        state.categories = categories;
    },
    SET_SERVICE_TO_EDIT: (state, serviceToEdit) => {
        state.serviceToEdit = serviceToEdit;
    },
    SET_PROPERTIES: (state, properties) => {
        state.properties = properties;
    },
    SET_CATEGORY: (state, category) => {
        state.category = category;
    },
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_CODE: (state, code) => {
        state.code = code;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_PROPERTY: (state, property) => {
        state.property = property;
    },
    SET_SERVICE_INSURANCES: (state, serviceInsurances) => {
        state.serviceInsurances = serviceInsurances;
    },
    SET_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('services',_.cloneDeep(payload.services));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'services', payload.services);
        }
        else vue.set(state, 'services', payload.items);
    },
    SET_LAB_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('labServices',_.cloneDeep(payload.labServices));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'labServices', payload.labServices);
        }
        else vue.set(state, 'labServices', payload.items);
    },
    SET_SERVICES_CATEGORIES: async (state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('serviceCategories',_.cloneDeep(payload.serviceCategories));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'serviceCategories', payload.serviceCategories);
        }
        else vue.set(state, 'serviceCategories', payload.items);
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
    SET_FEMALE_SURGERIES_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('femaleSurgeriesService',_.cloneDeep(payload.femaleSurgeriesService));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'femaleSurgeriesService', payload.femaleSurgeriesService);
        }
        else vue.set(state, 'femaleSurgeriesService', payload.items);
    },
    SET_MALE_SURGERIES_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('maleSurgeriesService',_.cloneDeep(payload.maleSurgeriesService));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'maleSurgeriesService', payload.maleSurgeriesService);
        }
        else vue.set(state, 'maleSurgeriesService', payload.items);
    },
    SET_FEMALE_SONOGRAPHIES_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('femaleSonographiesService',_.cloneDeep(payload.femaleSonographiesService));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'femaleSonographiesService', payload.femaleSonographiesService);
        }
        else vue.set(state, 'femaleSonographiesService', payload.items);
    },
    SET_MALE_SONOGRAPHIES_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('maleSonographiesService',_.cloneDeep(payload.maleSonographiesService));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'maleSonographiesService', payload.maleSonographiesService);
        }
        else vue.set(state, 'maleSonographiesService', payload.items);
    },
    SET_DISCOUNT_GROUPS: (state, discounts) =>{
        state.discountGroups = discounts;
    },
    SET_SERVICE_GROUPS: (state, serviceGroups) =>{
        state.serviceGroups = serviceGroups;
    },
    SET_SERVICE_GENDER: (state, serviceGender) =>{
        state.serviceGender = serviceGender;
    },
    RESET_MODULE (state) { // To reset the entire module
        // Object.assign(state, JSON.parse(JSON.stringify(initialState)))
        Object.assign(state, JSON.parse(JSON.stringify(_.cloneDeep(initialState))))
    },
    SET_MRI_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('mriServices',_.cloneDeep(payload.mriServices));
            if(payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'mriServices', payload.mriServices);
        }
        vue.set(state, 'mriServices', payload.items);
    },
    SET_CT_SCAN_SERVICES: async(state, payload) =>{
        if(!payload.items) {
            await localForage.setItem('ctScanServices', _.cloneDeep(payload.ctScanServices));
            if (payload.version) {
                await localForage.setItem('services-version', payload.version);
            }
            vue.set(state, 'ctScanServices', payload.ctScanServices);
        }
        vue.set(state, 'ctScanServices', payload.items);
    },

}
